// NavBar3 — combined sticky widget (Announcement Bar + Navigation).
// Parent (nav_bar) config carries the announcement bar + 3 CTAs + dropdown
// styling; children (menu_item) are the nav links with optional per-item icons.

export const NAVBAR_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    // Announcement bar
    announcement_bar_bg_color: "#FFFFFF",
    announcement_text: "Admissions are Open Now for Jan 2025 session",
    announcement_text_color: "#9F1C34",
    announcement_bg_color: "#F2E0E3",
    announcement_border_color: "#9F1C34",
    logo_icon: "",
    logo_icon_alt: "",
    logo_size_desktop: "small",
    logo_size_mobile: "small",
    // NULL/undefined also reads as ON in the widget — only an explicit false unlinks the logo.
    logo_redirect_enabled: true,
    // Nav row
    background_color: "#9F1C34",
    nav_text_color: "#FFFFFF",
    active_menu_color: "#F4BEBE",
    border_color: "rgba(0,0,0,0.2)",
    // Mobile-specific color overrides
    mobile_announcement_bg_color: "#9F1C34",
    mobile_announcement_text_color: "#FFFFFF",
    mobile_announcement_border_color: "#9F1C34",
    mobile_menu_text_color: "#000000",
    mobile_active_menu_color: "#9F1C34",
    // Dropdown
    dropdown_bg_color: "#F2E0E3",
    dropdown_text_color: "#000000",
    show_dropdown_icons: true,
    // CTA-1 (phone)
    cta1_enabled: true,
    cta1_icon: "",
    cta1_icon_alt: "Call",
    cta1_label: "+91 1234567890",
    cta1_href: "",
    cta1_bg_color: "transparent",
    cta1_text_color: "#000000",
    cta1_border_color: "#000000",
    // CTA-2 (WhatsApp)
    cta2_enabled: true,
    cta2_icon: "",
    cta2_icon_alt: "WhatsApp",
    cta2_label: "WhatsApp Chat",
    cta2_href: "",
    cta2_bg_color: "#4CAF51",
    cta2_text_color: "#FFFFFF",
    cta2_border_color: "transparent",
    // CTA-3 (Apply Now — optional; clearing the label hides the button)
    cta3_label: "Apply Now",
    cta3_icon: "",
    cta3_icon_alt: "Apply Now",
    cta3_bg_color: "#9F1C34",
    cta3_text_color: "#FFFFFF",
    // Mobile chrome
    hamburger_icon: "",
    hamburger_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    // --- Logo ---
    { fieldName: "logo_icon", label: "Logo", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload logo", required: true, defaultValue: "" },
    { fieldName: "logo_icon_alt", label: "Logo Alt Text", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter logo alt text", required: false, defaultValue: "" },
    // Wide university lockups need the larger boxes — the logo is contained
    // inside the box, so a narrow box shrinks a wide logo to fit its width.
    { fieldName: "logo_size_desktop", label: "Logo Size (Desktop)", value: "small", valueType: "string", filedType: "SELECT", placeholder: "Select desktop logo size", required: false, defaultValue: "small", className: "h-9 py-1.5 text-sm", iconClassName: "!size-4", options: [{ label: "Small (default)", value: "small" }, { label: "Medium", value: "medium" }, { label: "Large (full lockup)", value: "large" }] },
    { fieldName: "logo_size_mobile", label: "Logo Size (Mobile)", value: "small", valueType: "string", filedType: "SELECT", placeholder: "Select mobile logo size", required: false, defaultValue: "small", className: "h-9 py-1.5 text-sm", iconClassName: "!size-4", options: [{ label: "Small (default)", value: "small" }, { label: "Medium", value: "medium" }, { label: "Large", value: "large" }] },
    { fieldName: "logo_redirect_enabled", label: "Logo Links to Home", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Logo redirects to /", defaultValue: true, description: "On by default. Turn off on standalone landing pages so clicking the logo does nothing instead of navigating to /." },

    // --- Announcement bar ---
    { fieldName: "announcement_text", label: "Announcement Text", value: "", valueType: "string", filedType: "INPUT", placeholder: "e.g. Admissions are Open Now for Jan 2025 session", required: false, defaultValue: "" },
    { fieldName: "announcement_bg_color", label: "Announcement BG Color (Desktop)", value: "#F2E0E3", valueType: "string", filedType: "COLOR", placeholder: "#F2E0E3", required: false, defaultValue: "#F2E0E3" },
    { fieldName: "announcement_border_color", label: "Announcement Border Color (Desktop)", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "announcement_text_color", label: "Announcement Text Color (Desktop)", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "mobile_announcement_bg_color", label: "Announcement BG Color (Mobile)", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "mobile_announcement_border_color", label: "Announcement Border Color (Mobile)", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "mobile_announcement_text_color", label: "Announcement Text Color (Mobile)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "announcement_bar_bg_color", label: "Announcement Bar Background", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- CTA-1 (phone) ---
    { fieldName: "cta1_enabled", label: "Show CTA 1 (Phone)", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable CTA 1", defaultValue: true },
    { fieldName: "cta1_icon", label: "CTA 1 Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload CTA 1 icon", required: false, defaultValue: "" },
    { fieldName: "cta1_icon_alt", label: "CTA 1 Icon Alt", value: "Call", valueType: "string", filedType: "INPUT", placeholder: "Call", required: false, defaultValue: "Call" },
    { fieldName: "cta1_label", label: "CTA 1 Label", value: "", valueType: "string", filedType: "INPUT", placeholder: "+91 1234567890", required: false, defaultValue: "" },
    { fieldName: "cta1_href", label: "CTA 1 Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "tel:+911234567890", required: false, defaultValue: "" },
    { fieldName: "cta1_bg_color", label: "CTA 1 BG Color", value: "transparent", valueType: "string", filedType: "COLOR", placeholder: "transparent", required: false, defaultValue: "transparent" },
    { fieldName: "cta1_text_color", label: "CTA 1 Text Color", value: "#000000", valueType: "string", filedType: "COLOR", placeholder: "#000000", required: false, defaultValue: "#000000" },
    { fieldName: "cta1_border_color", label: "CTA 1 Border Color", value: "#000000", valueType: "string", filedType: "COLOR", placeholder: "#000000", required: false, defaultValue: "#000000" },

    // --- CTA-2 (WhatsApp) ---
    { fieldName: "cta2_enabled", label: "Show CTA 2 (WhatsApp)", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable CTA 2", defaultValue: true },
    { fieldName: "cta2_icon", label: "CTA 2 Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload CTA 2 icon", required: false, defaultValue: "" },
    { fieldName: "cta2_icon_alt", label: "CTA 2 Icon Alt", value: "WhatsApp", valueType: "string", filedType: "INPUT", placeholder: "WhatsApp", required: false, defaultValue: "WhatsApp" },
    { fieldName: "cta2_label", label: "CTA 2 Label", value: "", valueType: "string", filedType: "INPUT", placeholder: "WhatsApp Chat", required: false, defaultValue: "" },
    { fieldName: "cta2_href", label: "CTA 2 Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "https://wa.me/...", required: false, defaultValue: "" },
    { fieldName: "cta2_bg_color", label: "CTA 2 BG Color", value: "#4CAF51", valueType: "string", filedType: "COLOR", placeholder: "#4CAF51", required: false, defaultValue: "#4CAF51" },
    { fieldName: "cta2_text_color", label: "CTA 2 Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "cta2_border_color", label: "CTA 2 Border Color", value: "transparent", valueType: "string", filedType: "COLOR", placeholder: "transparent", required: false, defaultValue: "transparent" },

    // --- CTA-3 (Apply Now — optional; opens lead form when link empty) ---
    { fieldName: "cta3_label", label: "CTA 3 Label (Apply Now)", value: "", valueType: "string", filedType: "INPUT", placeholder: "Apply Now", required: false, defaultValue: "", description: "Leave blank to hide the Apply Now button entirely." },
    { fieldName: "cta3_icon", label: "CTA 3 Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload CTA 3 icon", required: false, defaultValue: "" },
    { fieldName: "cta3_icon_alt", label: "CTA 3 Icon Alt", value: "Apply Now", valueType: "string", filedType: "INPUT", placeholder: "Apply Now", required: false, defaultValue: "Apply Now" },
    { fieldName: "cta3_bg_color", label: "CTA 3 BG Color", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "cta3_text_color", label: "CTA 3 Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- Nav row ---
    { fieldName: "background_color", label: "Nav Background Color", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "nav_text_color", label: "Menu Text Color (Desktop)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "active_menu_color", label: "Active / Open Menu Color (Desktop)", value: "#F4BEBE", valueType: "string", filedType: "COLOR", placeholder: "#F4BEBE", required: false, defaultValue: "#F4BEBE" },
    { fieldName: "mobile_menu_text_color", label: "Menu Text Color (Mobile)", value: "#000000", valueType: "string", filedType: "COLOR", placeholder: "#000000", required: false, defaultValue: "#000000" },
    { fieldName: "mobile_active_menu_color", label: "Active Menu Color (Mobile)", value: "#9F1C34", valueType: "string", filedType: "COLOR", placeholder: "#9F1C34", required: false, defaultValue: "#9F1C34" },
    { fieldName: "border_color", label: "Border Color", value: "rgba(0,0,0,0.2)", valueType: "string", filedType: "COLOR", placeholder: "rgba(0,0,0,0.2)", required: false, defaultValue: "rgba(0,0,0,0.2)" },

    // --- Dropdown ---
    { fieldName: "show_dropdown_icons", label: "Show Dropdown Icons", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show icons on dropdown items", defaultValue: true },
    { fieldName: "dropdown_bg_color", label: "Dropdown BG Color", value: "#F2E0E3", valueType: "string", filedType: "COLOR", placeholder: "#F2E0E3", required: false, defaultValue: "#F2E0E3" },
    { fieldName: "dropdown_text_color", label: "Dropdown Text Color", value: "#000000", valueType: "string", filedType: "COLOR", placeholder: "#000000", required: false, defaultValue: "#000000" },

    // --- Mobile chrome ---
    { fieldName: "show_hamburger", label: "Show Hamburger Menu on Mobile", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)", defaultValue: true },
    { fieldName: "hamburger_icon", label: "Hamburger Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload hamburger icon", required: false, defaultValue: "" },
    { fieldName: "hamburger_icon_alt", label: "Hamburger Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Menu", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon", label: "Mobile Close Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload close icon", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon_alt", label: "Mobile Close Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Close", required: false, defaultValue: "" },

    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable widget", defaultValue: true },
  ],
};

export const MENU_ITEM_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "#FFFFFF",
    icon: "",
    icon_alt: "",
  },

  MENU_FIELDS_CONFIG: [
    { fieldName: "title", label: "Title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter menu title (e.g., MBA)", required: true, defaultValue: "" },
    { fieldName: "parent_id", label: "Parent Menu", value: null, valueType: "string", filedType: "SELECT", placeholder: "Select parent menu", required: false, defaultValue: null, options: [] },
    { fieldName: "slug", label: "Slug", value: "", valueType: "string", filedType: "INPUT", placeholder: "Auto-generated from title", defaultValue: "" },
    { fieldName: "url", label: "URL", value: "", valueType: "string", filedType: "INPUT", placeholder: "/programmes/mba (optional)", required: false, defaultValue: "" },
    { fieldName: "priority", label: "Priority", value: 1, valueType: "number", filedType: "INPUT", placeholder: "Enter display priority", required: true, defaultValue: 1 },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable menu item", defaultValue: true },
    { fieldName: "text_color", label: "Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "Enter text color (e.g., #FFFFFF)", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "icon", label: "Dropdown Item Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload item icon (optional)", required: false, defaultValue: "" },
    { fieldName: "icon_alt", label: "Dropdown Item Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter icon alt text", required: false, defaultValue: "" },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
    // PRD: max 10 nav links — block adding past 10 (top-level).
    itemLimits: { max: 10 },
  },
};
